import React from 'react';

const FirstPartyIcon = () => {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="90" height="90" fill="url(#pattern0_10_2)" />
      <defs>
        <pattern
          id="pattern0_10_2"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_10_2" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_10_2"
          width="90"
          height="90"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABgUlEQVR4nO3cTU5CQRBF4ZroGnSJ6kLAjalRlwEyV+bHGH8GRgySR72y+nwL4FbfVEjohI6QJEmSJO0GnALXwBPTWQPLt8/+JXosvBdyLMu5z1cG027yd5u5z1cGRzb3+crAoi26Fdxoi24FN9qiW8GNtuhWcKMtuhXc6LSi10fsepV0jBj9mnQx9/mqXfwvJ95sL/4PsavNgz5Mu1l0Etxoi24FN9qiW8GNtuhWcKO/ftldAbfAlv9vC9wAl8BJVACcA4/09QCcVdjkziV/up91sz++LkZxMWfRd4zjZs6iXxjH85xF/8isiVl0EotOYtFJLDqJRSex6CQWncSik1h0EotOYtGSJEkjPsWz/suTO12zMv9jshw5K/Mpns3IWXthIjFwVlQbiKZZUW0gmmZFtYFomhXVBqJpVlQbiKZZUW0gmmZFtYFomhXVBqJpVlQbiKZZUW0gmmZFtYFomrWXiR4sWY2cFYnXiYuRszKe4lkfcBnfLkuSJEmSJCkaeQU2JGaZA/AlvgAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
};

export default FirstPartyIcon;
